<template lang="html">
    <div>
       <v-toolbar text color="white">
        <v-toolbar-title>PACKAGE TYPES CODES ({{getData.length}})</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn @click="backToInvite" rounded color="primary">Back</v-btn>
      </v-toolbar>
        <br>
            <v-card-title class="justify-content-end">
                <v-flex md6 pr-2 >
                <h6>{{updatedDetailsForScreen}}</h6>
            </v-flex>
            <v-flex md3 pr-2 >
                <v-text-field v-model="search" label="Search"
                append-icon="mdi-magnify" single-line hide-details ></v-text-field>
            </v-flex>
        </v-card-title>
      <v-data-table :headers="headers" :items="getData" 
           :search="search" class="elevation-1">
        <template v-slot:item="props">
          <tr>
            <td class="text-xs-right" >{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.name }}</td>
            <td class="text-xs-right">{{ props.item.notes }}</td>
          </tr>
        </template>
<template v-slot:no-data>
          <span>No data found</span>
        </template>
</v-data-table>

</div>
</template>

<script>
    import MasterScreenService from "../../services/master-screenservices"
    import router from "../../router/index";

    export default {
        name: 'PackageTypes',
        data() {
            return {
                search: '',
                updatedDetailsForScreen: '',
                getData: [],
                headers: [{
                    text: "Code",
                    align: "left",
                    sortable: true,
                    value: "code"
                }, {
                    text: "Name",
                    align: "left",
                    sortable: true,
                    value: "name"
                }, {
                    text: "Notes",
                    align: "left",
                    sortable: true,
                    value: "notes"
                }, ],
            }
        },
        computed: {},
        created() {
            this.updatedDetailsForScreen = sessionStorage.getItem("updatedDetailsForScreen");
            MasterScreenService.getPackageTypes().then(response => {
                    this.getData = response.data;
                    console.log(this.getData);
                })
                .catch(e => {
                    console.log(e);
                });
        },

        methods: {            
            backToInvite() {
             router.push("/master-screen/cds-code-lists");
            }
        }
    }
</script>

<style>
    .justify-content-end {
        justify-content: Flex-end;
    }
</style>